import PropTypes, { number } from 'prop-types'
import React from 'react'
import useTranslation from 'next-translate/useTranslation'
import { connect } from 'react-redux'
import ReactSVG from 'react-svg'
import { getIsMobileDevice } from 'SRC/modules/common/selectors'
import { getPagination } from 'SRC/modules/vehicleParts/list/selectors'
import { getFilteredFields } from 'SRC/modules/vehicleParts/filter/selectors'
import { PriceSort } from 'SRC/modules/vehicleParts/filter/components/PriceSort/PriceSort'
import { SeasonFilter } from 'SRC/modules/vehicleParts/filter/components/Gume/SeasonFilter'
import { BreadCrumbsItem } from '../BreadCrumbsItem'
import translations from '../../../../../../public/data/translations.json'

const BCIcon = () => {
	return (
		<ReactSVG src='/icons/home-breadcrumbs.svg' beforeInjection={svg => {
			svg.setAttribute('style', 'width: 20px; height: auto; margin-right: 5px;')
		}} wrapper='span' className='ad-breadcrumbs__icon' />
	)
}

export const getBreadCrumbsItems = ({ filterValues, filteredFields, locale = 'ME', t }) => {
	const breadCrumbItems = [
		{ key: 'home', as: '/', href: { pathname: '/' }, text: t('Početna'), isLast: false }
	]

	let baseAs = `/${translations.noviDjeloviUrl[locale]}/${translations['auto-djelovi'][locale].gume.slug}`
	let baseHref = { pathname: '/vehicleParts', query: {} }

	console.log('filterValues', filterValues)
	console.log('filteredFields', filteredFields)

	breadCrumbItems.push({
		key: 'vehiclePartsGroup',
		as: baseAs,
		href: baseHref,
		text: filteredFields?.seo?.title,
		isLast: Object.keys(filterValues).filter(key => ['page', 'sortBy', 'text-filter', 'group'].includes(key)).length === 0
	})

	let asUrl = baseAs
	let hrefUrl = baseHref
	let urlPrefix = `/${translations.pretraga[locale]}?`

	if (filterValues.width) {
		asUrl += `${urlPrefix}width=${filterValues.width}`
		hrefUrl = { pathname: '/vehiclePartsSearch', query: { ...hrefUrl.query, width: filterValues.width } }

		breadCrumbItems.push({
			key: 'width',
			as: asUrl,
			href: hrefUrl,
			text: filterValues.width,
			isLast: false
		})

		urlPrefix = '&'
	}

	if (filterValues.height) {
		asUrl += `${urlPrefix}height=${filterValues.height}`
		hrefUrl = { pathname: '/vehiclePartsSearch', query: { ...hrefUrl.query, height: filterValues.height } }

		breadCrumbItems.push({
			key: 'height',
			as: asUrl,
			href: hrefUrl,
			text: filterValues.height,
			isLast: false
		})

		urlPrefix = '&'
	}

	if (filterValues.diameter) {
		asUrl += `${urlPrefix}diameter=${filterValues.diameter}`
		hrefUrl = { pathname: '/vehiclePartsSearch', query: { ...hrefUrl.query, diameter: filterValues.diameter } }

		breadCrumbItems.push({
			key: 'diameter',
			as: asUrl,
			href: hrefUrl,
			text: filterValues.diameter,
			isLast: false
		})

		urlPrefix = '&'
	}

	if (filterValues.season) {
		asUrl += `${urlPrefix}season=${filterValues.season}`
		hrefUrl = { pathname: '/vehiclePartsSearch', query: { ...hrefUrl.query, season: filterValues.season } }

		const season = filteredFields?.data?.season?.find(item => item.slug === filterValues.season)

		breadCrumbItems.push({
			key: 'season',
			as: asUrl,
			href: hrefUrl,
			text: season?.name,
			isLast: false
		})

		urlPrefix = '&'
	}

	if (filterValues.tire_vehicle_type) {
		asUrl += `${urlPrefix}tire_vehicle_type=${filterValues.tire_vehicle_type}`
		hrefUrl = { pathname: '/vehiclePartsSearch', query: { ...hrefUrl.query, tire_vehicle_type: filterValues.tire_vehicle_type } }

		const tireVehicleType = filteredFields?.data?.tire_vehicle_type?.find(item => item.slug === filterValues.tire_vehicle_type)

		breadCrumbItems.push({
			key: 'tire_vehicle_type',
			as: asUrl,
			href: hrefUrl,
			text: tireVehicleType?.name,
			isLast: false
		})

		urlPrefix = '&'
	}

	if (filterValues.manufacturer) {
		asUrl += `${urlPrefix}manufacturer=${filterValues.manufacturer}`
		hrefUrl = { pathname: '/vehiclePartsSearch', query: { ...hrefUrl.query, manufacturer: filterValues.manufacturer } }

		const manufacturer = filteredFields?.data?.manufacturer?.find(item => item.slug === filterValues.manufacturer)

		breadCrumbItems.push({
			key: 'manufacturer',
			as: asUrl,
			href: hrefUrl,
			text: manufacturer?.name,
			isLast: false
		})

		urlPrefix = '&'
	}

	if (filterValues.sortBy) {
		asUrl += `${urlPrefix}sortBy=${filterValues.sortBy}`
		hrefUrl = { pathname: '/vehiclePartsSearch', query: { ...hrefUrl.query, sortBy: filterValues.sortBy } }

		breadCrumbItems.push({
			key: 'sortBy',
			as: asUrl,
			href: hrefUrl,
			text: filterValues.sortBy === 'priceAsc' ? `${t('Cijena')}: ${t('Najjeftinije')}` : `${t('Cijena')}: ${t('Najskuplje')}`,
			isLast: false
		})

		urlPrefix = '&'
	}

	return breadCrumbItems
}

const CountText = ({ count }) => {
	const { t } = useTranslation('common')

	if (!count) return <span />
	if (count === 1) {
		return <span style={{ marginLeft: 'auto', fontSize: '1rem' }}><strong>1</strong> {t('proizvod pronađen')}</span>
	}

	if (count === 2) {
		return <span style={{ marginLeft: 'auto', fontSize: '1rem' }}><strong>2</strong> {t('pronađena proizvoda')}</span>
	}

	return <span style={{ marginLeft: 'auto', fontSize: '1rem' }}><strong>{count}</strong> {t('pronađenih proizvoda')}</span>
}

const BreadCrumbs = ({ filterValues, filteredFields, pagination, isMobileDevice, showParts }) => {
	const { lang, t } = useTranslation('common')
	const locale = lang?.toUpperCase() || 'ME'

	const breadCrumbItems = getBreadCrumbsItems({ filterValues, filteredFields, locale, t })

	return (
		<div className='ad-breadcrumbs ad-breadcrumbs__ads_list ad-breadcrumbs__vehicle-parts'>
			<BCIcon />

			{breadCrumbItems.map((breadCrumbItem, i) => (
				<BreadCrumbsItem
					key={breadCrumbItem.key}
					as={breadCrumbItem.as}
					href={breadCrumbItem.href}
					text={breadCrumbItem.text}
					isLast={i === breadCrumbItems.length - 1}
				/>
			))}

			{isMobileDevice || !showParts ? null : <CountText count={pagination?.totalCount || 0} />}

			{!isMobileDevice ? (
				<div className='vehicle-parts-breadcrumbs-container'>
					
						<div className='vehicle-parts-breadcrumbs-container__title_desc' style={{ width: '100%' }}>
							{filteredFields?.seo?.title ? <h1>{filteredFields?.seo?.title}</h1> : null}
						</div>

					{showParts && pagination?.totalCount ? (
						<>
							<SeasonFilter />
							<PriceSort />
						</>
					) : null}
				</div>
			) : (
				<div className='vehicle-parts-breadcrumbs-container vehicle-parts-breadcrumbs-container-mobile'>
					{showParts && pagination?.totalCount ? (
						<>
							<SeasonFilter />
							<PriceSort isMobileDevice={isMobileDevice} />
						</>
					) : null}
				</div>
			)}

		</div>
	)
}

BreadCrumbs.propTypes = {
	pagination: PropTypes.shape({
		totalCount: PropTypes.number
	}).isRequired,
	filteredFields: PropTypes.oneOf([
		PropTypes.shape({
			data: PropTypes.shape({
				group: PropTypes.arrayOf(PropTypes.shape({
					name: PropTypes.string.isRequired,
					slug: PropTypes.string.isRequired,
					image_path: PropTypes.string.isRequired
				})),
				category: PropTypes.arrayOf(PropTypes.shape({
					name: PropTypes.string.isRequired,
					slug: PropTypes.string.isRequired,
					image_path: PropTypes.string.isRequired
				})),
				car_brand: PropTypes.arrayOf(PropTypes.shape({
					name: PropTypes.string.isRequired,
					slug: PropTypes.string.isRequired,
					image_path: PropTypes.string.isRequired
				})),
				car_model: PropTypes.arrayOf(PropTypes.shape({
					name: PropTypes.string.isRequired,
					slug: PropTypes.string.isRequired
				})),
				year: PropTypes.arrayOf(PropTypes.shape({
					name: PropTypes.string.isRequired,
					slug: PropTypes.string.isRequired
				})),
				vehicle_type: PropTypes.arrayOf(PropTypes.shape({
					name: PropTypes.string.isRequired,
					slug: PropTypes.string.isRequired
				})),
				car_model_engine_info: PropTypes.arrayOf(PropTypes.shape({
					model: PropTypes.string.isRequired,
					tip_motora: PropTypes.string.isRequired,
					snaga_kw: PropTypes.string.isRequired,
					snaga_ks: PropTypes.string.isRequired,
					slug: PropTypes.string.isRequired
				}))
			}),
			seo: PropTypes.shape({
				title: PropTypes.string,
				description: PropTypes.string
			})
		}),
		PropTypes.shape({
			data: PropTypes.shape({
				width: PropTypes.arrayOf(PropTypes.shape({
					name: PropTypes.string.isRequired,
					slug: PropTypes.string.isRequired,
				})),
				height: PropTypes.arrayOf(PropTypes.shape({
					name: PropTypes.string.isRequired,
					slug: PropTypes.string.isRequired,
				})),
				diameter: PropTypes.arrayOf(PropTypes.shape({
					name: PropTypes.string.isRequired,
					slug: PropTypes.string.isRequired,
				})),
				manufacturer: PropTypes.arrayOf(PropTypes.shape({
					name: PropTypes.string.isRequired,
					slug: PropTypes.string.isRequired
				})),
				season: PropTypes.arrayOf(PropTypes.shape({
					name: PropTypes.string.isRequired,
					slug: PropTypes.string.isRequired
				})),
				vehicle_type: PropTypes.arrayOf(PropTypes.shape({
					name: PropTypes.string.isRequired,
					slug: PropTypes.string.isRequired,
					image_path: PropTypes.string.isRequired
				}))
			})
		}),
		PropTypes.shape({
			data: PropTypes.shape({
				voltage: PropTypes.arrayOf(PropTypes.shape({
					name: PropTypes.string.isRequired,
					slug: PropTypes.string.isRequired,
				})),
				capacity: PropTypes.arrayOf(PropTypes.shape({
					name: PropTypes.string.isRequired,
					slug: PropTypes.string.isRequired,
				})),
				width: PropTypes.arrayOf(PropTypes.shape({
					name: PropTypes.string.isRequired,
					slug: PropTypes.string.isRequired,
				})),
				height: PropTypes.arrayOf(PropTypes.shape({
					name: PropTypes.string.isRequired,
					slug: PropTypes.string.isRequired
				})),
				length: PropTypes.arrayOf(PropTypes.shape({
					name: PropTypes.string.isRequired,
					slug: PropTypes.string.isRequired
				})),
				manufacturer: PropTypes.arrayOf(PropTypes.shape({
					name: PropTypes.string.isRequired,
					slug: PropTypes.string.isRequired,
				}))
			})
		}),
		PropTypes.shape({
			data: PropTypes.shape({
				category: PropTypes.arrayOf(PropTypes.shape({
					name: PropTypes.string.isRequired,
					slug: PropTypes.string.isRequired,
					image_path: PropTypes.string.isRequired
				})),
				manufacturer: PropTypes.arrayOf(PropTypes.shape({
					name: PropTypes.string.isRequired,
					slug: PropTypes.string.isRequired,
				})),
			})
		})
	]).isRequired,
	filterValues: PropTypes.oneOf([
		PropTypes.shape({
			car_brand: PropTypes.string,
			car_model: PropTypes.string,
			group: PropTypes.string,
			category: PropTypes.string,
			year: PropTypes.string,
			vehicle_type: PropTypes.string
		}),
		PropTypes.shape({
			width: PropTypes.string,
			height: PropTypes.string,
			diameter: PropTypes.string,
			manufacturer: PropTypes.string,
			season: PropTypes.string,
			tire_vehicle_type: PropTypes.string
		}),
		PropTypes.shape({
			voltage: PropTypes.string,
			capacity: PropTypes.string,
			width: PropTypes.string,
			height: PropTypes.string,
			length: PropTypes.string,
			manufacturer: PropTypes.string
		}),
		PropTypes.shape({
			category: PropTypes.string,
			manufacturer: PropTypes.string
		})
	]).isRequired,
	showParts: PropTypes.bool
}

BreadCrumbs.defaultProps = {
	showParts: true
}

CountText.propTypes = {
	count: PropTypes.number.isRequired,
}

const mapStateToProps = state => {
	return {
		pagination: getPagination(state),
		filteredFields: getFilteredFields(state),
		isMobileDevice: getIsMobileDevice(state)
	}
}

export default connect(mapStateToProps)(BreadCrumbs)
